import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InventoryDocumentsPage } from '@/features/inventory'

export const Route = createFileRoute('/_authenticated/inventory/documents')({
  component: () => (
    <RequirePermission permission='inventory_requests.read'>
      <InventoryDocumentsPage />
    </RequirePermission>
  ),
})
